import React from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';

import HabilitationService from 'services/habilitationsService';
import { Axios } from 'helpers/axios';

const Logout = () => {

    const disconnectSession = async () => {
        const tokenToClean = HabilitationService.token;
        HabilitationService.disconnect();
        await Axios.post('/publicroutes/dropSession',
        {
            jwtToken: tokenToClean,
        });
        location.reload();
    }

    return (<>
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
            <Dropdown.Item as={Link} onClick={disconnectSession}>
                Se déconnecter
            </Dropdown.Item>
        </div>
    </>);
};

Logout.propTypes = {};

export default Logout;
